import React, { useState, useEffect } from "react";
import { db } from "./firebase";
import { collection, query, onSnapshot } from "firebase/firestore";

function Results() {
  const [costumes, setCostumes] = useState([]);
  const [votes, setVotes] = useState([]);

  // costumes tally
  useEffect(() => {
    const q = query(collection(db, "costumes"));
    const unsub = onSnapshot(q, (snapshot) => {
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCostumes(list);
    });
    return () => unsub();
  }, []);

  // ballots
  useEffect(() => {
    const q = query(collection(db, "votes"));
    const unsub = onSnapshot(q, (snapshot) => {
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setVotes(list);
    });
    return () => unsub();
  }, []);

  const categories = [
    { field: "scariest", label: "Scariest Costume" },
    { field: "sexiest", label: "Sexiest Costume" },
    { field: "cutest", label: "Cutest Costume" },
    { field: "funniest", label: "Funniest Costume" },
    { field: "bestDIY", label: "Best DIY Costume" },
    { field: "bestCouples", label: "Best Couples Costume" },
    { field: "bestOverall", label: "Best Costume (Champion)" }
  ];

  const top3 = (field) => {
    return [...costumes]
      .filter((c) => c.votes && c.votes[field])
      .sort((a, b) => b.votes[field] - a.votes[field])
      .slice(0, 3);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h1>Contest Results</h1>

      {categories.map((cat) => (
        <div key={cat.field} style={{ marginBottom: "30px" }}>
          <h2>{cat.label}</h2>
          <ul>
            {top3(cat.field).map((c, idx) => (
              <li key={c.id}>
                #{idx + 1} {c.name} — {c.votes[cat.field]} votes
              </li>
            ))}
          </ul>
        </div>
      ))}

      <h2>🗳️ Ballots Cast</h2>
      <ul>
        {votes.map((v) => (
          <li key={v.id} style={{ marginBottom: "15px" }}>
            <strong>{v.voterName}</strong> voted:
            <ul>
              {Object.entries(v.selections || {}).map(([catField, choice]) => (
                <li key={catField}>
                  {catField}: {choice.costumeName}
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Results;
